export enum Platforms {
    desktopWEB = 'desktopWEB',
    desktopPWA = 'desktopPWA',
    tabletWEB = 'tabletWEB',
    tabletPWA = 'tabletPWA',
}
export type Platform = keyof typeof Platforms

export const desktopPlatforms: Platform[] = ['desktopPWA', 'desktopWEB']
export const mobilePlatforms: Platform[] = ['tabletPWA', 'tabletWEB']
